export default __webpack_public_path__ + "static/media/laboh_logo.81fd96f8.png";